import { auth } from "./auth";
import { offlineStore } from "./offlineDb";

const baseUrl = (import.meta.env.VITE_API_BASE_URL || "https://api.ocheleague.com").replace(/\/$/, "");

export const getContext = async () => ({
  organizationId: await offlineStore.getPreference("organizationId"),
  leagueId: await offlineStore.getPreference("leagueId")
});

export const setContext = async ({ organizationId, leagueId, organizationName, leagueName }) => {
  await Promise.all([
    offlineStore.setPreference("organizationId", organizationId),
    offlineStore.setPreference("leagueId", leagueId || null),
    offlineStore.setPreference("organizationName", organizationName || ""),
    offlineStore.setPreference("leagueName", leagueName || "")
  ]);
};

export const apiRequest = async (path, options = {}) => {
  const token = await auth.token();
  const context = await getContext();
  const headers = new Headers(options.headers || {});
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (!options.contextOptional && context.organizationId) headers.set("X-Organization-Id", context.organizationId);
  if (!options.contextOptional && context.leagueId) headers.set("X-League-Id", context.leagueId);
  const response = await fetch(`${baseUrl}${path}`, { ...options, headers });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.error || body.title || `Request failed (${response.status}).`);
    error.status = response.status;
    error.details = body;
    throw error;
  }
  return response.status === 204 ? null : response.json();
};

export const syncQueuedOperations = async () => {
  if (!navigator.onLine) return { sent: 0, remaining: (await offlineStore.getQueue()).length };
  let sent = 0;
  for (const operation of await offlineStore.getQueue()) {
    try {
      await apiRequest(operation.path, {
        method: operation.method,
        body: operation.body ? JSON.stringify(operation.body) : undefined
      });
      await offlineStore.removeQueued(operation.id);
      sent += 1;
    } catch (error) {
      if (error.status && error.status < 500 && error.status !== 408 && error.status !== 429) throw error;
      break;
    }
  }
  return { sent, remaining: (await offlineStore.getQueue()).length };
};
